/**
 * List-collections toolbar.
 *
 * Adds client-side filter (search by name) and sort (A–Z, Z–A) for
 * the cards on the /collections (Browse Schools) page. Uses a
 * MutationObserver on the grid so that when infinite scroll appends
 * more pages, the current filter + sort are automatically re-applied
 * to the newly added cards.
 *
 * Empty-state message shows when search yields no matches.
 */
(function () {
  function init() {
    var toolbar = document.querySelector('.collections-toolbar');
    var grid = document.querySelector('#product-grid.collection-list');
    if (!toolbar || !grid) return;
    new ListCollectionsToolbar(toolbar, grid);
  }

  function ListCollectionsToolbar(toolbar, grid) {
    this.toolbar = toolbar;
    this.grid = grid;
    this.search = toolbar.querySelector('.collections-toolbar__search');
    this.sort = toolbar.querySelector('.collections-toolbar__sort');
    this.empty = toolbar.querySelector('.collections-toolbar__empty');
    this.debounceTimer = null;

    if (this.search) {
      this.search.addEventListener('input', this.onSearchInput.bind(this));
    }
    if (this.sort) {
      this.sort.addEventListener('change', this.applySort.bind(this));
    }

    this.observeGrid();
    this.applySort();
  }

  ListCollectionsToolbar.prototype.onSearchInput = function () {
    var self = this;
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(function () {
      self.applyFilter();
    }, 100);
  };

  ListCollectionsToolbar.prototype.observeGrid = function () {
    var self = this;
    this.observer = new MutationObserver(function (mutations) {
      // Look only at *new* nodes (not nodes we ourselves moved around
      // via applySort — those are existing children being repositioned,
      // and replaying applySort on them creates an infinite loop).
      var hasGenuinelyNew = mutations.some(function (m) {
        if (m.type !== 'childList') return false;
        for (var i = 0; i < m.addedNodes.length; i++) {
          var node = m.addedNodes[i];
          if (node.nodeType !== 1) continue;
          if (!node.dataset.sortKey) return true; // unseen before
        }
        return false;
      });
      if (hasGenuinelyNew) {
        self.applyFilter();
        self.applySort();
      }
    });
    this.observer.observe(this.grid, { childList: true });
  };

  ListCollectionsToolbar.prototype.disconnect = function () {
    if (this.observer) this.observer.disconnect();
  };

  ListCollectionsToolbar.prototype.reconnect = function () {
    if (this.observer) this.observer.observe(this.grid, { childList: true });
  };

  ListCollectionsToolbar.prototype.applyFilter = function () {
    var q = this.search ? this.search.value.trim().toLowerCase() : '';
    var items = this.grid.querySelectorAll('.collection-list__item');
    var visibleCount = 0;
    items.forEach(function (item) {
      var heading = item.querySelector('.card__heading');
      var name = heading ? heading.textContent.toLowerCase().trim() : '';
      var match = !q || name.indexOf(q) !== -1;
      if (match) {
        item.removeAttribute('hidden');
        visibleCount++;
      } else {
        item.setAttribute('hidden', '');
      }
    });
    if (this.empty) {
      this.empty.hidden = !(q && visibleCount === 0);
    }
  };

  ListCollectionsToolbar.prototype.applySort = function () {
    if (!this.sort) return;
    var mode = this.sort.value;
    var items = Array.prototype.slice.call(
      this.grid.querySelectorAll('.collection-list__item')
    );
    if (items.length < 2) return;

    // Cache the sort key on the element itself the first time we see
    // it, so subsequent sorts don't have to re-query .card__heading
    // and re-read textContent for every comparison.
    items.forEach(function (item) {
      if (!item.dataset.sortKey) {
        var heading = item.querySelector('.card__heading');
        item.dataset.sortKey = heading
          ? heading.textContent.trim().toLowerCase()
          : '';
      }
    });

    items.sort(function (a, b) {
      return a.dataset.sortKey.localeCompare(b.dataset.sortKey, undefined, {
        sensitivity: 'base',
      });
    });
    if (mode === 'alpha-desc') items.reverse();

    // Bail out if the existing DOM order already matches what we'd sort
    // to — no point thrashing the DOM just to end up where we started.
    var existing = this.grid.children;
    var alreadySorted = items.every(function (item, i) {
      return existing[i] === item;
    });
    if (alreadySorted) return;

    // Disconnect the MutationObserver before moving nodes around —
    // our own reorder would otherwise trigger it and create a loop.
    this.disconnect();
    var fragment = document.createDocumentFragment();
    items.forEach(function (item) {
      fragment.appendChild(item);
    });
    this.grid.appendChild(fragment);
    this.reconnect();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
